"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomáš Leity
 */


var SimulatedKpiValueDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimulatedKpiValueDTO, _DomainObject_1$Domai);

  /**
   * @param value
   * @param affectedBySimulation
   */
  function SimulatedKpiValueDTO(value, affectedBySimulation) {
    var _this;

    _classCallCheck(this, SimulatedKpiValueDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimulatedKpiValueDTO).call(this));
    _this.value = value;
    _this.affectedBySimulation = affectedBySimulation;
    return _this;
  }

  _createClass(SimulatedKpiValueDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SimulatedKpiValueDTO(mat.value, mat.affectedBySimulation);
    }
  }]);

  return SimulatedKpiValueDTO;
}(DomainObject_1.DomainObject);

exports.SimulatedKpiValueDTO = SimulatedKpiValueDTO;

SimulatedKpiValueDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimulatedKpiValueDTO.name);
  return {
    value: builder.opt(builder.bigNum('value')),
    affectedBySimulation: builder.bool('affectedBySimulation')
  };
}();